import { rem } from 'polished'
import styled, { css } from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const LISTING_DRAWER_MAX_WIDTH_PX = 800

/** Trip Planner drawer body horizontal padding — mobile aligns with LuxKit modal gutter. */
export const DRAWER_BODY_HORIZONTAL_PADDING_MOBILE = rem(20)
export const DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP = rem(24)

export const drawerBodyInlinePaddingStyles = css`
  padding-inline-start: ${DRAWER_BODY_HORIZONTAL_PADDING_MOBILE};
  padding-inline-end: ${DRAWER_BODY_HORIZONTAL_PADDING_MOBILE};

  ${mediaQueryUp.tablet} {
    padding-inline-start: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
    padding-inline-end: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
  }
`

export const drawerBodyInlineStartPaddingStyles = css`
  padding-inline-start: ${DRAWER_BODY_HORIZONTAL_PADDING_MOBILE};

  ${mediaQueryUp.tablet} {
    padding-inline-start: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
  }
`

export const drawerBodyContentPaddingStyles = css`
  padding-block-start: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
  padding-block-end: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
  ${drawerBodyInlinePaddingStyles}
`

export const drawerBodyEmptyStatePaddingStyles = css`
  padding-block-start: ${rem(48)};
  padding-block-end: ${rem(48)};
  ${drawerBodyInlinePaddingStyles}
`

export const DrawerBodyContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  ${drawerBodyContentPaddingStyles}
`
